type AnalysisTitleSource =
  | {
      title?: string | null;
    }
  | null
  | undefined;

/**
 * The display name for an analysis. Titles are set at creation and when the job
 * description is parsed, but there's a short window before parsing finishes
 * (plus a small tail of analyses whose JD never parsed) with no title, so
 * callers pass a fallback suited to their screen.
 */
export const getAnalysisTitle = (
  candidateBatch: AnalysisTitleSource,
  fallback = ''
): string => (candidateBatch?.title?.trim() ? candidateBatch.title : fallback);
